import cloneDeep from "lodash.clonedeep"

import {
    SimilarCategories,
    SimilarPsys,
} from "modules/PsyProfile/components/FAQContainer/components"
import { Psychologist } from "utils/interfaces"
import {
    aboutAlter,
    aboutBooking,
    aboutWorkWithPsychologist,
    ifYouAreNotSure,
} from "components/FAQ/FAQItems"

export function SimilarPsyLinks(psy: Psychologist) {
    const result = [aboutWorkWithPsychologist, aboutBooking]

    const ifYouAreNotSureBlock = cloneDeep(ifYouAreNotSure)
    ifYouAreNotSureBlock.content.push(SimilarCategories({ psy }))
    ifYouAreNotSureBlock.content.push(
        SimilarPsys({ identity: psy.hash_id, competences: psy.competences })
    )
    result.push(ifYouAreNotSureBlock)
    result.push(aboutAlter)
    return result
}
